/**
 * A document's or spreadsheet's review pane (comments and findings in place: office/review/useReview.tsx) handed to
 * the item page's side panel, where its issues and reviews are: one panel, not one beside the other.
 */

import { signal } from "@preact/signals";
import { setSideShown } from "../../lib/itemSide.ts";
import type { NotesPane } from "../../office/review/notes.ts";

/** The pane of the item whose document is shown, for the side panel. */
export const notesSlot = signal<{ item: string; pane: NotesPane } | null>(null);

/** Asks the item page for its review form (a finding with nothing selected: about the item as a whole). */
export const reviewAsked = signal(0);

/** The side panel's section with the pane (its id, to show it). */
export const NOTES_ID = "item-notes";

/** Shows the side panel, at its notes. */
export function showNotes(): void {
  setSideShown(true);
  requestAnimationFrame(() =>
    document.getElementById(NOTES_ID)?.scrollIntoView({ block: "nearest", behavior: "smooth" }),
  );
}
